<div class="c-dp-search__block c-dp-search__block--own">
  <div class="c-dp-search__action">
    <label *ngIf="isAmendmentFlow && !isItemCloseable" class="a-checkbox c-dp-search__action-check">
      <input type="checkbox" class="a-checkbox__check" (change)="checkValue($event)" [checked]="!freeze">
      <span class="a-checkbox__label"></span>
    </label>
    <div class="c-dp-search__block-icon">
      <svg class="a-icon">
        <use xlink:href="#products--ownarrangment"></use>
      </svg>
    </div>
  </div>

  <div class="c-dp-search__block-label">
    <svg class="a-icon u-rmr">
      <use xlink:href="#products--hotel"></use>
    </svg>
    <span class="lbl">Own Arrangement</span>
  </div>
  <div class="c-dp-search__form-wrap">
    <span class="a-loz a-loz--success c-dp-search__form-tag" *ngIf="isAmendmentFlow && isItemCloseable">Newly Added</span>
  <div class="c-dp-search__form c-dp-search__form--own">
    <div class="c-dp-search__form-item">
      <div class="m-form-item">
        <surf-input
          [label]="'Name*'"
          [placeholder]="'Name of your own arrangement'"
          [inputVal]="payloadObject?.name"
          [disabled]="freeze"
          [warningStyle]="'is-visited'"
          [warning]="nameWarning"
          (value)="setName($event)">
        </surf-input>
      </div>
    </div>
    <div class="c-dp-search__form-item c-dp-search__form-item--inverted">
      <surf-date-picker [inputLabel]="datePickerLabel"
                        [(isFocused)]="datePickerFocus"
                        [calendar_start_date]="calenderStartDate"
                        [reset]="resetCalendar"
                        [check_availability]="true"
                        [range]="CALENDAR_RANGE"
                        [initial_dates]="initialDates"
                        [disabled]="freeze"
                        [warningStyle]="'is-visited'"
                        [warning1]="departureDateWarning"
                        [warning2]="returnDateWarning"
                        [isError]="validateDisabledDateSelection"
                        [invalidErrorMsg]="validateDisabledDateSelection ? SURF_ERROR_MESSAGES.LAST_MINUTE_BOOKING_VALIDATION_ERROR_MESSAGE : ''"
                        [hideErrorMsg]="hideErrorMsg"
                        [validateDisabledDateSelection]="validateDisabledDateSelection"
                        (selected_duration)="setSelectedDuration($event)"
                        (selected_dates)="setSelectedDateRange($event)"
                        [tabIndex]="3">
      </surf-date-picker>
    </div>

    <div class="c-dp-search__form-item c-dp-search__form-item--desc">
      <div class="m-form-item">
        <surf-input
          [label]="'Description'"
          [placeholder]="'Description of your own arrangement'"
          [inputVal]="payloadObject?.description"
          [disabled]="freeze"
          [warningStyle]="'is-visited'"
          [warning]="descriptionWarning"
          (value)="setDescription($event)">
        </surf-input>
      </div>
    </div>
  </div>

  </div>
  <div [hidden]="!isItemCloseable" class="c-dp-search__close" (click)="removeItem()">
    <svg class="a-icon">
      <use xlink:href="#close"></use>
    </svg>
  </div>
</div>
<!---->
<!---->
